export const CLICK_BTN_GETINVITED = 'CLICK_BTN_GETINVITED'
export const CLICK_BTN_RECOVER_WALLET = 'CLICK_BTN_RECOVER_WALLET'
export const CLICK_BTN_CARD_ACTION = 'CLICK_BTN_CARD_ACTION'
export const CLICK_DELETE_WALLET = 'CLICK_DELETE_WALLET'
export const SIGNUP_SELECTED = 'SIGNUP_SELECTED'
export const SIGNIN_SELECTED = 'SIGNIN_SELECTED'
export const SIGNUP_METHOD_SELECTED = 'SIGNUP_METHOD_SELECTED'
export const SIGNIN_METHOD_SELECTED = 'SIGNIN_METHOD_SELECTED'
export const SIGNUP_EXISTS = 'SIGNUP_EXISTS'
export const SIGNUP_EXISTS_LOGIN = 'SIGNUP_EXISTS_LOGIN'
export const SIGNUP_EXISTS_CONTINUE = 'SIGNUP_EXISTS_CONTINUE'
export const SIGNUP_RETRY_SMS = 'SIGNUP_RETRY_SMS'
export const SIGNUP_RETRY_EMAIL = 'SIGNUP_RETRY_EMAIL'
export const SIGNIN_NOTEXISTS_SIGNUP = 'SIGNIN_NOEXISTS_SIGNUP'
export const SIGNIN_NOTEXISTS_LOGIN = 'SIGNIN_NOTEXISTS_LOGIN'
export const SIGNIN_TORUS_SUCCESS = 'TORUS_SIGNIN_SUCCESS'
export const TORUS_SUCCESS = 'TORUS_SUCCESS'
export const TORUS_FAILED = 'TORUS_FAILED'
export const TORUS_POPUP_CLOSED = 'TORUS_POPUP_CLOSED'
export const TORUS_REDIRECT_SUCCESS = 'TORUS_REDIRECT_SUCCESS'
export const SIGNIN_SUCCESS = 'MAGICLINK_SUCCESS'
export const SIGNIN_FAILED = 'MAGICLINK_FAILED'
export const RECOVER_SUCCESS = 'RECOVER_SUCCESS'
export const RECOVER_FAILED = 'RECOVER_FAILED'
export const CLAIM_SUCCESS = 'CLAIM_SUCCESS'
export const CLAIM_FAILED = 'CLAIM_FAILED'
export const CLAIM_QUEUE = 'CLAIM_QUEUE_UPDATED'
export const CLAIM_GEO = 'CLAIM_GEO'
export const CARD_OPEN = 'CARD_OPEN'
export const PROFILE_PRIVACY = 'PROFILE_PRIVACY'
export const PROFILE_IMAGE = 'PROFILE_IMAGE'
export const PROFILE_UPDATE = 'PROFILE_UPDATE'
export const PHRASE_BACKUP = 'PHRASE_BACKUP'
export const PHRASE_BACKUP_COPY = 'PHRASE_BACKUP_COPY'
export const ADDTOHOME = 'ADDTOHOME'
export const ADDTOHOME_LATER = 'ADDTOHOME_LATER' // desktop/chrome did user accept or reject the install prompt
export const ADDTOHOME_OK = 'ADDTOHOME_OK'
export const ADDTOHOME_REJECTED = 'ADDTOHOME_REJECTED'
export const GOTO_GOODSWAP = 'GOTO_GOODSWAP'
export const GOTO_LEARN = 'GOTO_LEARN'
export const GOTO_USEGD = 'GOTO_USEGD'
export const GOTO_DONATE = 'GOTO_DONATE'
export const GOTO_VOTE = 'GOTO_VOTE'
export const ERROR_LOG = 'ERROR'
export const QR_SCAN = 'QR_SCAN'
export const APP_OPEN = 'APP_OPEN'
export const LOGOUT = 'LOGOUT'
export const CARD_SLIDE = 'CARD_SLIDE'
export const FV_INTRO = 'FV_INTRO' //first fv screen
export const FV_START = 'FV_START' //user continue after instructions to  loading facetec UI
export const FV_CAMERAPERMISSION = 'FV_CAMERAPERMISSION'
export const FV_INSTRUCTIONS = 'FV_INSTRUCTIONS' //second screen shown after zoom sdk is loadeed
export const FV_GETREADY_ZOOM = 'FV_GETREADY_ZOOM' //zoom getready screen before startig actuall FV
export const FV_PROGRESS_ZOOM = 'FV_PROGRESS_ZOOM' //face being uploaded to server for liveness
export const FV_ZOOMFAILED = 'FV_ZOOMFAILED'
export const FV_SUCCESS_ZOOM = 'FV_SUCCESS_ZOOM'
export const FV_TRYAGAIN_ZOOM = 'FV_TRYAGAIN_ZOOM'
export const FV_GENERALERROR = 'FV_GENERALERROR'
export const FV_WRONGORIENTATION = 'FV_WRONGORIENTATION'
export const FV_DUPLICATEERROR = 'FV_DUPLICATEERROR'
export const FV_NOTMATCHERROR = 'FV_NOTMATCHERROR'
export const FV_TRYAGAINLATER = 'FV_TRYAGAINLATER'
export const FV_CANTACCESSCAMERA = 'FV_CANTACCESSCAMERA'
export const FV_GIVEUP = 'FV_GIVEUP'
export const INVITE_SHARE = 'INVITE_SHARE' //user pressed on any of the sharing options
export const INVITE_JOIN = 'INVITE_JOIN' //user joined after he was invited
export const INVITE_BOUNTY = 'INVITE_BOUNTY' //user collected his bounties
export const INVITE_HOWTO = 'INVITE_HOWTO' //user pressed howto invite
export const ANALYTICS_EVENT = 'Analytics_event' // event name for google analytics
export const PAYMENT_CATEGORY_SELECTED = 'PAYMENT_CATEGORY_SELECTED' // event name for google analytics
export const RECEIVE_DONE = 'RECEIVE_DONE'
export const WITHDRAW = 'WITHDRAW'
export const RESENDING_MAGICLINK_SUCCESS = 'RESENDING_MAGICLINK_SUCCESS'
export const SEND_DONE = 'SEND_DONE'
export const SEND_CONFIRMATION_SHARE = 'SEND_CONFIRMATION_SHARE'
export const ERROR_DIALOG = 'ERROR_DIALOG'
export const UPDATE_SUCCESS = 'UPDATE_SUCCESS'
export const UPDATE_FAILED = 'UPDATE_FAILED'
export const GOTO_WELCOME = 'GOTO_WELCOME'
export const CLICK_LEARNMORE = 'CLICK_LEARNMORE'
export const CLICK_GETSTARTED = 'CLICK_GETSTARTED'
export const GOTO_CHOOSEAUTH = 'GOTO_CHOOSEAUTH'
export const GOTO_TOKENDASHBOARD = 'GOTO_TOKENDASHBOARD'
export const GOTO_TAB_FEED = 'GOTO_TAB_FEED'
export const GOTO_SPONSOR = 'GOTO_SPONSOR'
export const SCROLL_FEED = 'SCROLL_FEED'
export const GOOD_AIRDROP = 'GOOD_AIRDROP'
export const NOTIFICATION_SENT = 'NOTIFICATION_SENT'
export const NOTIFICATION_RECEIVED = 'NOTIFICATION_RECEIVED'
export const NOTIFICATION_TAPPED = 'NOTIFICATION_TAPPED'
export const NOTIFICATION_ERROR = 'NOTIFICATION_ERROR'
export const GOVERNANCE_JOINSNAPSHOT = 'GOVERNANCE_JOINSNAPSHOT'
export const SWITCH_NETWORK = 'SWITCH_NETWORK'
export const REWARD_RECEIVED = 'REWARD_RECEIVED'
